// extracted by mini-css-extract-plugin
export var actionButton = "_gx-0";
export var attachmentLine = "_gx-1";
export var fileInput = "_gx-2";
export var fileUploadWrapper = "_gx-4";
export var footer = "_gx-3";
export var modalContent = "_gx-5";
export var paperclip = "_gx-6";
export var quillEditor = "_gx-7";